export type WorkspaceAccess = {
  id: number;
  workspaceId: number;
  userId: number;
  fullName: string;
  role: string;
  createdAt: Date;
  updatedAt: Date;
};

export enum WorkspaceAccessRole {
  Owner = 'Owner',
  Member = 'Member',
}
